import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import teamService from '../services/teamService';
import { queryKeys } from './queryKeys';

export function useTeams(searchQuery, options = {}) {
  return useQuery({
    queryKey: queryKeys.teams.all,
    queryFn: () => teamService.getAllTeam(searchQuery),
    staleTime: 60 * 1000,
    refetchOnMount: 'always',
    ...options,
  });
}

export function useAdminTeams(searchQuery, options = {}) {
  return useQuery({
    queryKey: queryKeys.teams.admin(searchQuery),
    queryFn: () => teamService.getFilteredTeamList(searchQuery),
    staleTime: 60 * 1000,
    refetchOnMount: 'always',
    ...options,
  });
}

export function useDeleteTeam(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id => teamService.deleteTeam(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.teams.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useCreateTeam(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => teamService.createTeam(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.teams.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useUpdateTeam(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => teamService.updateTeam(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.teams.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
